import React, { useEffect, useState } from "react";
import { Box, Grid, Paper, Typography, Chip, IconButton, Divider } from '@mui/material';
import { observer } from "mobx-react-lite";
import { withRouter } from "react-router-dom";
import StyledSubHeader from "../../common/StyledSubHeader";
import StyledPage from "../../common/StyledPage";
import { StyledLoadingSection } from "../../common/StyledProgressCircle";
import { isAdmin } from "../../../actions/profile/UserActions";
import { getUserId } from "../../../selectors/UserSelectors";
import { NOTIFICATION_TYPE, showNotificationBar } from "../../../actions/error-pages/NotificationBarActions";
import { getEmailByIdForAdmin } from "../../../actions/internal/AdminActions";
import { getEmailById } from "../../../selectors/AdminSelectors";
import StyledSection from "../../common/StyledSection";
import { TextButton } from "../../common/StyledButtons";
import { Edit } from "@mui/icons-material";
import { SUMMARY_TITLE_FONT } from '../../../constants/Styles';

const AdminViewEmailPage = ({ history, match }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [email, setEmail] = useState(null);

  const emailId = match.params.emailId;

  const loadData = async () => {
    if (!isAdmin()) {
      history.replace('/dashboard');
      return;
    }

    try {
      const userId = getUserId();
      const result = await getEmailByIdForAdmin(userId, emailId);
      setEmail(result);
    } catch (err) {
      console.error(err);
      showNotificationBar(
        NOTIFICATION_TYPE.ERROR,
        'Unable to load email.'
      );
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  if (isLoading) {
    return <StyledLoadingSection />;
  }

  if (!email) {
    return (
      <StyledPage>
        <Typography>Email not found.</Typography>
      </StyledPage>
    );
  }

  const { email_content, email_status } = email || {};
  const { recipients, subject, body } = email_content || {};

  const renderCreateNewEmailButton = () => (
    <IconButton
      onClick={() => history.push(`/admin/email-marketing/${emailId}/edit`)}
      sx={{ display: 'flex', alignItems: 'center', padding: '4px' }}
    >
      <Edit fontSize="small" sx={{ marginRight: '4px' }} />
    </IconButton>
    );

  return (
    <StyledPage>
      <StyledSubHeader title="View Email" />

      <StyledSection
            title={'View Email'}
            rightAdornment={renderCreateNewEmailButton()}
        >
            <div style={{marginTop: '30px', marginBottom: '18px' }}><span style={{paddingRight: '40px', ...SUMMARY_TITLE_FONT }}>Status</span>{email_status}</div>
            <Divider />
            <div style={{marginTop: '10px', marginBottom: '10px' }}><span style={{paddingRight: '40px', ...SUMMARY_TITLE_FONT }}>Recipients</span></div>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, paddingBottom: '10px' }}>
              {recipients && recipients.map((r, i) => (
                <Chip key={i} label={r.email || r} />
              ))}
            </Box>
            <Divider />
            <div style={{marginTop: '10px', marginBottom: '10px' }}><span style={{paddingRight: '40px', ...SUMMARY_TITLE_FONT }}>Subject</span>{subject}</div>
            <Divider />
            <div style={{marginTop: '10px', marginBottom: '10px' }}><span style={{paddingRight: '40px', ...SUMMARY_TITLE_FONT }}>Message</span></div>
            <Box
              sx={{
                border: '1px solid #ddd',
                borderRadius: 1,
                padding: 2,
                marginTop: 1,
                backgroundColor: '#fafafa'
              }}
              dangerouslySetInnerHTML={{ __html: body }}
            />
        </StyledSection>
    </StyledPage>
  );
};

export default withRouter(observer(AdminViewEmailPage));
